exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3.title[data-v-27aceaf5] {\n  padding: 20px;\n  font-size: 18px;\n  color: #ff5000;\n}\n.col-3[data-v-27aceaf5] {\n  width: 120px;\n  margin-right: 10px;\n}\n.detail-info[data-v-27aceaf5] {\n  margin: 0 10px;\n}\n.el-row[data-v-27aceaf5] {\n  margin-bottom: 10px;\n}\n.item-image[data-v-27aceaf5] {\n  max-width: 80px;\n  margin: 0 auto;\n}\nimg[data-v-27aceaf5] {\n  max-width: 100px;\n  margin: 0 auto;\n}\n.block[data-v-27aceaf5] {\n  margin-left: 85px;\n}\n.radio[data-v-27aceaf5] {\n  margin-bottom: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-27aceaf5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/trade/order/detail.vue
// module id = 1315
// module chunks = 0